import React, {useState} from 'react';
import ModalContainer from "../../../../components/ModalContainer";
import TextButton from "../../../../components/common/TextButton";
import Button from "../../../../components/common/Button";
import styles from './styles.module.scss';

interface IProps {
    handleClose: () => void;
    handleEditFilter: (from?: number, to?: number) => void;
    initFrom: string;
    initTo: string;
}

const ModalDurationFilter = ({handleClose, handleEditFilter, initFrom, initTo}: IProps) => {
    const [from, setFrom] = useState<string>(initFrom);
    const [to, setTo] = useState<string>(initTo);
    const [error, setError] = useState<string | null>(null);

    const handleSave = () => {
        const fromVal = from !== '' ? Number(from) : undefined;
        const toVal = to !== '' ? Number(to) : undefined;

        if (fromVal !== undefined && toVal !== undefined && fromVal > toVal) {
            setError("'From' must be less than or equal to 'To'");
            return;
        }

        handleEditFilter(fromVal, toVal);
        handleClose();
    };

    return (
        <ModalContainer handleClose={handleClose}>
            <div className={styles.modal}>
                <h2 className={styles.modal__subtitle}>
                    Filter Duration
                </h2>
                <input
                    autoFocus
                    type="number"
                    className={styles.modal__input}
                    placeholder={'From sec'}
                    value={from}
                    onChange={(e) => {
                        setFrom(e.target.value);
                        setError(null);
                    }}
                />
                <input
                    type="number"
                    className={styles.modal__input}
                    placeholder={'To sec'}
                    value={to}
                    style={{marginTop: '10px'}}
                    onChange={(e) => {
                        setTo(e.target.value);
                        setError(null);
                    }}
                />
                {error && <div style={{color: '#d32f2f', fontSize: '14px', marginTop: '8px'}}>{error}</div>}
                <div className={styles.modal__footer}>
                    <div className={styles.modal__btn}>
                        <TextButton
                            text={'Cancel'}
                            onClick={handleClose}
                        />
                    </div>
                    <div className={styles.modal__btn}>
                        <Button
                            text={'Apply'}
                            onClick={handleSave}
                        />
                    </div>
                </div>
            </div>
        </ModalContainer>
    );
};

export default ModalDurationFilter;
